import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import withData from '@bd/bdcore-data';
import { Image } from '@bd/bdcore-utilities';

import { colors } from '../styles';
import ContactModal from './ContactModal';
import { BtnAnimationSheen } from '../helpers/UIElements';
import icons from './IconsList';

const styles = css`
  background-color: #f9f9f9;
  padding: 70px 0;
  @media(min-width: 992px) {
    padding: 55px 0;
  }
  .CTAComponent_wrapper {
    max-width: 1500px;
  }
  .CTAComponent_image {
    width: 159px;
    height: 159px;
    border-radius: 50%;
    object-fit: cover;
    object-position: center top;
    @media(min-width: 992px) {
      width: 212px;
      height: 212px;
    }
  }
  .CTAComponent_title {
    font-weight: 300;
    font-size: 40px;
    color: ${colors.color3};
    letter-spacing: 0;
    text-align: center;
    line-height: 42px;
    @media(min-width: 992px) {
      font-size: 48px;
    }
  }
  .CTAComponent_subtitle {
    font-weight: 700;
    font-size: 15px;
    color: ${colors.color1};
    letter-spacing: 1.3px;
    text-align: center;
    text-transform: uppercase;
    @media(min-width: 992px) {
      font-size: 20px;
      letter-spacing: 1.74px;
    }
  }
  .CTAComponent_span {
    font-size: 16px;
    color: ${colors.color1};
    letter-spacing: 0;
  }
  .CTAComponent_btn {
    background-color: ${colors.color1};
    background-repeat: no-repeat;
    height: 100%;
    display: flex;
    align-items: center;
    font-weight: 700;
    font-size: 17px;
    color: #FFFFFF;
    letter-spacing: 0;
    min-height: 63px;
    position: relative;
    padding: 0 20px;
    cursor: pointer;
    @media(min-width: 992px) {
      padding: 0 35px;
      min-height: 71px;
    }
    &::before {
      content: '';
      background-image: url(${get(icons, 'started')});
      background-repeat: no-repeat;
      background-position: center;
      width: 33px;
      height: 28px;
      margin-right: 15px;
    }
  }
  .CTAComponent_content {
    padding: 36px 0 0;
    margin: 30px 0 0;
    position: relative;
    @media(min-width: 992px) {
      margin: 20px 0 0;
      padding: 10px 0 0;
    }
    &::after, &::before {
      content: none;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      width: 100px;
      height: 1px;
      background-color: #575757;
      @media(min-width: 992px) {
        transform: none;
        left: 0;
        width: 150px;
      }
    }
    &::after {
      top: 0;
    }
    &::before {
      top: 6px;
      @media(min-width: 92px) {
        top: 7px;
      }
    }
  }
`;

function CTAComponent({ agent, widget, type }) {
  return (
    <div className={styles}>
      <div className="CTAComponent_wrapper mx-auto">
        <div className="d-lg-flex">
          <div className="col-lg-3 d-flex flex-column align-items-center justify-content-center mb-4 mb-lg-0">
            <Image
              src={get(agent, 'logo.contentUrl')}
              alt={get(agent, 'name')}
              className="CTAComponent_image mb-2 mt-5 mt-lg-0"
            />
            <a href={`tel:${get(agent, 'telephone').replace(/[^0-9]/g, '')}`} className="CTAComponent_subtitle">
              {get(agent, 'telephone').replace(/\s-\s/, '-')}
            </a>
          </div>
          <div className="flex-fill d-flex flex-column justify-content-center">
            <h4 className="CTAComponent_title px-3">{`${get(widget, 'title')} ${type}!`}</h4>
            <span className="CTAComponent_subtitle px-3">
              {get(widget, 'subtitle')}
            </span>
            <div className="d-flex justify-content-center CTAComponent_content">
              {/* <div className="flex-fill d-none d-lg-flex flex-column pt-lg-3">
                <span className="CTAComponent_span"><b>Ne
                w Home Specialist</b> {get(agent, 'name')}</span>
                {
                  get(community, 'hours') &&
                  <span className="CTAComponent_span"><b>Hours</b> {get(community, 'hours')}</span>
                }
              </div> */}
              <ContactModal>
                <BtnAnimationSheen className="CTAComponent_btn">
                  Get Started
                </BtnAnimationSheen>
              </ContactModal>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

CTAComponent.propTypes = {
  widget: PropTypes.object.isRequired,
  agent: PropTypes.object,
  type: PropTypes.string.isRequired,
};

CTAComponent.defaultProps = {
  className: '',
  agent: undefined,
};

export default withData(
  {
    agent: true,
    widget: 'cta_widget',
  },
  {
    required: {
      widget: true,
      agent: true,
    },
  },
)(CTAComponent);



// WEBPACK FOOTER //
// ./src/components/CTAComponent.js